import React from 'react';

import {ErrorModalTemplate} from '../../../components/DataDisplay';
import * as localizationKeys from '../../../consts/localization/localizationKeys';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import hidReconnectHandlerService from '../../../services/hid/hidReconnectHandlerService';
import iqosHidService from '../../../services/hid/iqosHidService';
import iotService from '../../../services/iot/iotService';
import {getLocalizedStrings} from '../../../services/localization/localizationService';
import modalService from '../../../services/modalService';
import pairingService from '../../../services/pairingService';

const HidReconnectPopupTemplate = (props) => {
    const {modalType, descriptionKey} = props;
    const localizedStrings = getLocalizedStrings();
    const onClose = () => modalService.hideModal(modalType);
    const onClick = async () => {
        try {
            await iqosHidService.connect({
                onConnect: async () => {
                    try {
                        await iotService.initIotService({isReconnect: true});
                        onClose();
                    } catch (e) {
                        pairingService.disconnectAndShowReconnectError();
                    }
                },
            });
            // eslint-disable-next-line no-empty
        } catch (e) {
            hidReconnectHandlerService.showHidReconnectModal();
        }
    };
    const onSkipClick = () => {
        onClose();
        pairingService.disconnectAndForwardToStartPage();
    };

    useDocumentTitle(localizedStrings[localizationKeys.ACCESSIBILITY_USB_RECONNECT_POPUP_TITLE]);

    return (
        <ErrorModalTemplate
            titleKey={localizationKeys.USB_RECONNECT_POPUP_TITLE_TEXT}
            descriptionKey={descriptionKey}
            buttonPrimary={{
                isConnectionTrack: true,
                onClick,
                textKey: localizationKeys.USB_POPUP_BTN_RECONNECT,
            }}
            buttonSecondary={{
                onClick: onSkipClick,
                textKey: localizationKeys.USB_POPUP_BTN_RECONNECT_SKIP,
            }}
        />
    );
};

export default HidReconnectPopupTemplate;
